import React from 'react';
import styles from './Categories.css';
import {  FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {  faShoppingCart } from '@fortawesome/free-solid-svg-icons';

const Categories = () => {
        return (
            <div className={styles.categoriesMenu}>
                <nav >
                    <ul>
                        <li><a href="#nigiri">Nigiri</a></li>
                        <li><a href="#maki">Maki</a></li>
                        <li><a href="#soups">Soups</a></li>
                        <li><a href="#sweets">Sweets</a></li>
                        <li><a href="#bevereges">Bevereges</a></li>
                        <li><a href="#order">Order <FontAwesomeIcon icon={faShoppingCart} size='xs'/></a></li>
                    </ul>     
                </nav>               
            </div>
        )
    }
export default Categories;






// WEBPACK FOOTER //
// ./src/components/Menu/Categories/Categories.js